var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChartBar = function SvgChartBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CBD5E1",
    d: "M18.333 18.333H1.667a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h16.666a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBD5E1",
    d: "M8.125 3.334v15h3.75v-15c0-.917-.375-1.667-1.5-1.667h-.75c-1.125 0-1.5.75-1.5 1.667"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBD5E1",
    d: "M2.5 8.334v10h3.333v-10c0-.917-.333-1.667-1.333-1.667h-.667c-1 0-1.333.75-1.333 1.667M14.167 12.5v5.833H17.5V12.5c0-.917-.333-1.667-1.333-1.667H15.5c-1 0-1.333.75-1.333 1.667",
    opacity: 0.35
  })));
};
export default SvgChartBar;